import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import cn from 'classnames';

import BrIcons from '@components/BrIcons';
import BrText from '@components/BrText';
import BrTooltip from '@components/BrTooltip';
import ColorStyles from '@components/ColorStyles';
import './BrTipLabel.scss';

export default class BrTipLabel extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
    tip: PropTypes.string.isRequired,
    tipLocation: PropTypes.oneOf(Object.values(BrTooltip.Locations)),
  };

  static defaultProps = {
    tipLocation: BrTooltip.Locations.bottom,
  };

  render() {
    const { className, text, tip, tipLocation } = this.props;
    const classes = cn('br-tip-label', className);
    return (
      <div className={classes} data-id="br-tip-label">
        <BrText className="tip-label-text">{text}</BrText>
        <BrTooltip location={tipLocation} isDark>
          &nbsp;
          <BrIcons.Question disableHover colorStyle={ColorStyles.BLACK} isSubComp />
          <BrTooltip.Tooltip>{tip}</BrTooltip.Tooltip>
        </BrTooltip>
      </div>
    );
  }
}
